import { v4 } from "uuid";

export const TAB_SESSION_ID = v4();
